// Shared Google Maps configuration
// This ensures all components use the same library array reference
// to prevent LoadScript from reloading unintentionally

export const GOOGLE_MAPS_LIBRARIES = ["places", "geometry"];

// Use environment variable if available, otherwise fallback to hardcoded key
// export const GOOGLE_MAPS_API_KEY = "AIzaSyBfShd4gjL3LN1MhxkMYj1E7lY9atMq01k";
export const GOOGLE_MAPS_API_KEY = "AIzaSyCPwrm8VAsEw-LgpwMQGizWSUTWLh20ekY";
// process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
//   ||
//   "AIzaSyBLaecrWWZg2VIWS2rxw0utKfio7k9B5oc";

// Alternative API key used in Register component
export const GOOGLE_MAPS_API_KEY_REGISTER =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY_REGISTER ||
  "AIzaSyCPwrm8VAsEw-LgpwMQGizWSUTWLh20ekY";
